// Monthly packages are no longer sold self-service. Existing subscriptions keep working,
// and sales can still create a proposal in the ERP that the customer activates.
export const SUBSCRIPTION_SALES_ENABLED: boolean = false
